import React from 'react';
import SkeletonBlock from './SkeletonBlock';

export default function CalendarGridSkeleton({
  columns = 5,
  showToolbar = true,
  label = 'Loading calendar',
  className = '',
}) {
  const headerCells = Array.from({ length: columns + 1 }, (_, index) => index);
  const bodyCells = Array.from({ length: 8 * (columns + 1) }, (_, index) => index);

  return (
    <div
      className={`sk-host sk-calendar ${className}`.trim()}
      style={{ '--sk-cal-cols': columns }}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      {showToolbar ? (
        <div className="sk-calendar__toolbar">
          <div className="sk-calendar__toolbar-left">
            <SkeletonBlock width={36} height={32} />
            <SkeletonBlock width={36} height={32} />
            <SkeletonBlock width={160} height={16} />
          </div>
          <div className="sk-calendar__toolbar-right">
            <SkeletonBlock variant="pill" width={72} height={28} />
            <SkeletonBlock variant="pill" width={72} height={28} />
            <SkeletonBlock variant="pill" width={72} height={28} />
          </div>
        </div>
      ) : null}
      <div className="sk-calendar__grid">
        {headerCells.map((index) => (
          <SkeletonBlock key={`h-${index}`} className="sk-calendar__cell" width="100%" height={28} />
        ))}
        {bodyCells.map((index) => (
          <SkeletonBlock
            key={`c-${index}`}
            className="sk-calendar__cell"
            width={index % (columns + 1) === 0 ? '70%' : `${60 + ((index * 17) % 35)}%`}
            height={index % 4 === 0 ? 22 : 14}
          />
        ))}
      </div>
    </div>
  );
}
